// extracted by mini-css-extract-plugin
export default {"wrapper":"QurealApp_wrapper__8aASG"};